module.exports = __webpack_public_path__ + "static/media/sc30_styleframe03_v001.42ce856e.webp";